export default "__VITE_ASSET__BKw9nuh2__"